(() => {
  if (customElements.get('products-carousel')) {
    return;
  }

  class ProductsCarousel extends HTMLElement {
    constructor() {
      super();

      this.slider = {};
      this.controls = null;
      this.controlsWrapper = this.querySelector('[data-controls-wrapper]');
      this.shouldDestroyOnDesktop = this.hasAttribute('data-destroy');
      this.breakpoints = {
        desktop: 990
      };
    }

    connectedCallback() {
      this.initSlider();
      this.toggleSliderHandler();
      window.addEventListener('resize', debounce(this.toggleSliderHandler.bind(this), 500));
    }

    initSlider() {
      const sliderList = this.querySelector('.splide');

      if (!sliderList) return;

      this.controls = this.querySelectorAll('[data-control]');
      this.controls.forEach((control) => {
        control.addEventListener('click', this.onControlClick.bind(this));
      });
      this.slider = new Splide(this.querySelector('.splide'), {
        trimSpace: 'move',
        waitForTransition: false,
        flickMaxPages: 0.5,
        fixedWidth: '25%',
        gap: '1rem',
        pagination: false,
        arrows: false,
        breakpoints: {
          [this.breakpoints.desktop]: {
            fixedWidth: '74%',
            gap: '3.2rem'
          }
        }
      }).mount();
    }

    toggleSliderHandler() {
      if (!this.shouldDestroyOnDesktop) return;
      try {
        this.toggleSlider(window.innerWidth >= this.breakpoints.desktop);
      } catch(e) {}
    }

    toggleSlider(destroy) {
      this.slider[destroy ? 'destroy' : 'mount'](destroy);
      this.controlsWrapper.classList.toggle('hidden', destroy);
    }

    onControlClick(event) {
      event.preventDefault();

      if (this.slider === {}) {
        return;
      }

      const action = event.target.hasAttribute('data-prev') ? '<' : '>';

      this.slider.go(action);
    }
  }

  customElements.define('products-carousel', ProductsCarousel);
})();

document.addEventListener( 'DOMContentLoaded', function () {
  new Splide( '#card-carousel', {
		perPage    : 2,
		breakpoints: {
			640: {
				perPage: 1,
			},
		},
  } ).mount();
} );